import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/index.scss'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(ElementUI, { size: 'medium' })

Vue.config.productionTip = false

// 路由守卫
router.beforeEach((to, from, next) => {
  NProgress.start()

  const token = store.getters.token

  if (to.path === '/login') {
    if (token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (token) {
      if (!store.getters.name) {
        store.dispatch('user/getInfo').then(() => {
          next()
        }).catch(() => {
          store.dispatch('user/logout').then(() => {
            next({ path: '/login' })
          })
        })
      } else {
        next()
      }
    } else {
      next({ path: '/login' })
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
